var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, Injector } from '@angular/core';
import { SeoAwareBaseComponent } from '../common-theme/seo/seo-aware-base.component';
import { AgencyService } from '../common-theme/api/agency.service';
var DowntownLifeComponent = /** @class */ (function (_super) {
    __extends(DowntownLifeComponent, _super);
    function DowntownLifeComponent(agencyService, injector) {
        var _this = _super.call(this, injector) || this;
        _this.agencyService = agencyService;
        _this.injector = injector;
        _this.isOpen = [true, false, false, false, false];
        _this.navLinks = [
            { path: '/romanescu-lifestyle/concept' },
            { path: '/romanescu-lifestyle/detalii-proiect' },
            { path: '/romanescu-lifestyle/galerie' },
            { path: '/romanescu-lifestyle/facilitati' },
            { path: '/romanescu-lifestyle/tehnic' },
            { path: '/romanescu-lifestyle/construction' }
        ];
        return _this;
    }
    DowntownLifeComponent.prototype.ngOnInit = function () {
        this.setTitle(this.agencyService.agency.name);
    };
    return DowntownLifeComponent;
}(SeoAwareBaseComponent));
export { DowntownLifeComponent };



// WEBPACK FOOTER //
// ./src/app/downtown-life/downtown-life.component.ts.pre-build-optimizer.js